"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var CopyLanguageCacheService = /** @class */ (function () {
    function CopyLanguageCacheService(cookieService) {
        this.cookieService = cookieService;
        /**
         * Cookie name storing the Copy Language Cache.
         * Cookie value structure: 'curLangId=x;y,z...', where curLangId is the system language id for which
         * the values were cached, and 'y,z...' are ids of copy languages.
         * @type {string}
         */
        this.COPY_LANGUAGES_COOKIE = 'copyLangCache';
    }
    CopyLanguageCacheService.prototype.getCachedLanguageIds = function (currentLangId) {
        if (!this.hasCopyLanguageCache()) {
            return [];
        }
        var cachedValue = this.cookieService.get(this.COPY_LANGUAGES_COOKIE).split(';');
        var cacheLangId = Number(cachedValue[0].split('=').pop());
        if (cacheLangId !== currentLangId) {
            this.clearCopyCache();
            return [];
        }
        else {
            return cachedValue[1] ? cachedValue[1].split(',')
                .map(function (id) { return Number(id.trim()); })
                .filter(function (id) { return !isNaN(Number(id)); }) : [];
        }
    };
    CopyLanguageCacheService.prototype.cacheLanguageIds = function (currentLangId, ids) {
        this.cookieService.set(this.COPY_LANGUAGES_COOKIE, "curLangId=" + currentLangId + ";" + ids.join(','));
    };
    CopyLanguageCacheService.prototype.hasCopyLanguageCache = function () {
        return !!this.cookieService.get(this.COPY_LANGUAGES_COOKIE);
    };
    CopyLanguageCacheService.prototype.clearCopyCache = function () {
        this.cookieService.delete(this.COPY_LANGUAGES_COOKIE);
    };
    CopyLanguageCacheService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.CookieService])
    ], CopyLanguageCacheService);
    return CopyLanguageCacheService;
}());
exports.CopyLanguageCacheService = CopyLanguageCacheService;
//# sourceMappingURL=copy-language-cache.service.js.map